import {httpCore} from "./instance/http";

export const postErrorLog = params => httpCore.post('callme/rest/error-log', params);